import { defineStore } from 'pinia';
import { useIndexStore } from './IndexStore';
import GatewayService from '@/service/GatewayService';

export const useGatewayStore = defineStore('gatewayStore', {
  state: () => ({
    gateways: [],
    gatewayName: {},
    listGateways: [],
    gatewayByWord: []
  }),
  getters: {
    selectGateways: (state) => state.gateways,
    selectGatewayName: (state) => {
      const filterGateway = state.gateways.filter((s) => {
        return s.code === state.gatewayName;
      });
      return filterGateway;
    },
    selectListGateways: (state) => state.listGateways,
    selectGatewayByWord: (state) => state.gatewayByWord
  },
  actions: {
    async getGateways() {
      const gatewayService = new GatewayService();
      try {
        const res = await gatewayService.getGateways();
        if (res) {
          this.updateGateways(res.data);
        }
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async getGateWaysByDestination(id) {
      const Service = new GatewayService();
      const res = await Service.getGateWaysByDestination(id);
      return res?.data;
    },
    async getDestinationsByGateCode(gateCode) {
      const Service = new GatewayService();
      const res = await Service.getDestinationsByGateCode(gateCode);
      return res?.data;
    },
    async getGateWaysByDestinationDuration(destId, duration) {
      const Service = new GatewayService();
      const res = await Service.getGateWaysByDestinationDuration(destId, duration);
      return res?.data;
    },

    async getGateWayDuration(gateCode, destSVId, departureDate) {
      if (!gateCode || !destSVId) {
        return [];
      }
      const Service = new GatewayService();
      const payload = {
        gateCode,
        destSVId,
        departureDate
      };
      const res = await Service.getGatewayDuration(payload);
      return res?.data;
    },
    getDurationByGatewayAndDestination(gateCode, destCode, gatewayDuration = []) {
      const gatewaySelected = this.gateways.filter((obj) => obj.code === gateCode);
      const myMap = new Map(Object.entries(gatewaySelected[0]?.destDurations ?? {}));
      const destDurations = myMap.get(destCode) || [];
      const durations = destDurations?.concat(gatewayDuration) || [];

      const sortedUniqueDurations = durations
        ?.sort((a, b) => a - b)
        ?.filter((value, index, array) => {
          return array?.indexOf(value) === index;
        });

      return sortedUniqueDurations;
    },
    updateGateways(payload) {
      this.gateways = payload;
    },
    updateNewGateway(payload) {
      this.listGateways = payload;
    },
    getGatewayName(payload) {
      this.gatewayName = payload;
    },
    getGatewaySelectedQuote(payload) {
      const gatewayFind = this.gateways.filter((s) => {
        return s.code === payload;
      });
      return gatewayFind[0];
    }
  }
});
